<template>
  <div class="animated fadeIn mb-3" v-if="globals.query_by_zip_object.ZipCode">
    <b-row>
      <b-col lg="6">
        <b>Zip</b>
      </b-col>
      <b-col lg="6">
        {{ globals.query_by_zip_object.ZipCode }}
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="6">
        <b>City</b>
      </b-col>
      <b-col lg="6">
        {{ globals.query_by_zip_object.City }}
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="6">
        <b>State</b>
      </b-col>
      <b-col lg="6">
        {{ globals.query_by_zip_object.State }}
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="6">
        <b>Quantity</b>
      </b-col>
      <b-col lg="6">
        {{ globals.query_by_zip_object.Quantity }}
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b>Found In:</b>
      </b-col>
    </b-row>
    <b-row
      v-for="t in globals.query_by_zip_object.BelongsToWithChecks"
      :key="t"
    >
      <b-col lg="12">
        {{ t }}
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "ZipCard",
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState(["seminar", "territory", "zip", "globals", "n_user"])
  },
  methods: {},
  created() {},
  watch: {
    "$store.state.zip.current_territory_zips": function(newValue, oldValue) {},
    current_seminar: function(newValue, oldValue) {}
  }
};
</script>

<style lang="scss" scoped></style>
